import type { SourceTab } from "../../api/types.js";

export function SourceTabs({
  tab,
  setTab
}: {
  tab: SourceTab;
  setTab: (tab: SourceTab) => void;
}) {
  return (
    <nav className="drawer-tabs">
      <button className={tab === "cited" ? "active" : ""} onClick={() => setTab("cited")}>本轮引用</button>
      <button className={tab === "pool" ? "active" : ""} onClick={() => setTab("pool")}>文献池</button>
      <button className={tab === "assets" ? "active" : ""} onClick={() => setTab("assets")}>对话中的资料</button>
    </nav>
  );
}
